import { PLACEHOLDER } from 'components/column-renderers'
import { UIModal } from 'features/UI'
import { useShowControl } from 'hooks/useShowControl'
import React, { SyntheticEvent } from 'react'

export function TeamRoleCell({ roles }: { roles: string[] }) {
  const [isOpen, onOpen, onClose] = useShowControl()

  const handleOpen = (event: SyntheticEvent) => {
    event.preventDefault()
    onOpen()
  }

  if (roles.length === 0) {
    return <div>{PLACEHOLDER}</div>
  }

  return (
    <div>
      <a href="" onClick={handleOpen}>
        {roles.length}
      </a>

      <UIModal isOpen={isOpen} onClose={onClose} title="Roles">
        {roles.join(', ')}
      </UIModal>
    </div>
  )
}
